import { THEME } from '@lyon/utils/theme';
import { BlockOverrides } from 'baseui/block';

export const CONTAINER: BlockOverrides = {
  Block: {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      marginTop: '80px',
      width: 'calc(100% - 48px)',
      marginLeft: '24px',
      marginRight: '24px',

      [THEME.media.large]: {
        gridTemplateColumns: '1.5fr 1fr',
        gridColumnGap: '96px',
        width: '100%',
        marginLeft: 0,
        marginRight: 0,
      },
    },
  },
};
